<template>
  <div>
    <div width="100%" style="background-color: #CCC; border-radius: 3px; padding-left: 10px; border: 1px solid;">
      <span class="font-weight-bold text-uppercase h-4">{{ aItems[nIndex].Pregunta }}</span>
    </div>
    <div width="100%" style="border: 1px solid; border-radius:3px; padding-left: 10px;">
      <ul class="double">
        <li v-for="(oDataProcess, i) in aDataProcess" :key="i">
          <span>{{ oDataProcess.Correo }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    aItems: Array,
    nIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      aDataProcess: [],
    }
  },
  mounted() {
    this.proccessData()
  },
  methods: {
    proccessData () {
      if (("Detalle" in this.aItems[this.nIndex]) && this.aItems[this.nIndex].Detalle !== null) {
        const Details = JSON.parse(this.aItems[this.nIndex].Detalle.toString().trim().replace(/(\r\n|\n|\r)/gm, ""))
        this.aDataProcess = Details
      }
    },
  },
}
</script>
<style>
  .double{
    columns: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
  }
</style>